import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { formatPhone } from 'app/utils/fieldUtils'
// TODO: import the specific validations you need rather than using the validations object
import validations, { namedMinLength, namedValueBetween, validateZip } from 'app/utils/validations'
import oversightstates from '../constants/oversight-states'

const AddEditAuditForm = ({ auditingUnitCode, auditFiscalYear, auditTypeCode, organizationId, organizationEntityTypeId, auditLocationCode, auditNumber, notificationDate, closeOutDate,
  vaPocFirstName, vaPocMiddleInitial, vaPocLastName, vaPocEmail, vaPocPrimaryPhone, vaPocSecondaryPhone, orgPocFirstName, orgPocMiddleInitial,
  orgPocLastName, orgPocEmail, orgPocAddressOne, orgPocAddressTwo, orgPocCity, orgPocStateCode, orgPocZip, orgPocPrimaryPhone, orgPocSecondaryPhone,
  auditRecord, handleSubmit, handleInvalid, handleChange, handleDateChange, handleReset, errors, dateErrors, isEdit, canCreateAll, focusRef }) => {
    
  const fullAuditNumber = () => {
    if (organizationEntityTypeId === '1' || organizationEntityTypeId  === 1) {
      return auditLocationCode + auditFiscalYear + '-'
    } else if (organizationEntityTypeId === '2' || organizationEntityTypeId  === 2) {
      if (auditLocationCode === 'T') {
        return 'S' + auditFiscalYear + '-'
      }
      if (auditLocationCode === 'V') {
        return 'SV'  + auditFiscalYear + '-'
      }
    }
    return ''
  }

  return <div className='add-edit-audit-form usa-grid'>
    <h1>{isEdit ? 'Edit Audit' : 'Create New Audit'}</h1>
    <form onSubmit={handleSubmit} autoComplete='off'>
      <fieldset>
        <legend>Audit Information</legend>
        {/* TODO: Convert all dropdowns to enums rather than one letter codes */}
        {canCreateAll && <BasicLgySelectField label='Auditing Unit' id='auditingUnitCode' name='auditingUnitCode' required value={auditingUnitCode} onChange={handleChange}
          onInvalid={handleInvalid} error={errors.auditingUnitCode ? errors.auditingUnitCode : undefined} autoFocus inputref={focusRef}>
          <option value='M'>Monitoring Unit</option>
          <option value='Q'>Quality Assurance</option>
        </BasicLgySelectField>}
        <BasicLgyInputField label='Fiscal Year' type='number' id='auditFiscalYear' name='auditFiscalYear' min='1900' max='2100' placeholder='YYYY' autoFocus={!canCreateAll}
          value={auditFiscalYear} onChange={handleChange} required onInvalid={handleInvalid} inputref={!canCreateAll ? focusRef : undefined}
          error={errors.auditFiscalYear ? errors.auditFiscalYear : namedValueBetween('Fiscal Year', 1900, 2100)(auditFiscalYear)} />
        <BasicLgySelectField label='Audit Type' id='auditTypeCode' name='auditTypeCode' value={auditTypeCode} onChange={handleChange} required
          onInvalid={handleInvalid} error={errors.auditTypeCode ? errors.auditTypeCode : undefined}>
          <option value='L'>Loan Origination</option>
          <option value='S'>Servicing</option>
          {auditingUnitCode === 'Q' && <option value='O'>OIG Inquiry</option>}
          {auditingUnitCode === 'Q' && <option value='R'>Other</option>}
        </BasicLgySelectField>
        <BasicLgySelectField label='Affiliate Type' id='organizationEntityTypeId' name='organizationEntityTypeId' required value={organizationEntityTypeId}
          onChange={handleChange} onInvalid={handleInvalid} error={errors.organizationEntityTypeId ? errors.organizationEntityTypeId : undefined}>
          {auditTypeCode !== 'S' && <option value='1'>Lender</option>}
          {auditTypeCode !== 'L' && <option value='2'>Servicer</option>}
        </BasicLgySelectField>
        <BasicLgyInputField label='Lender/Servicer ID' type='number' id='organizationId' name='organizationId' min='0' max='999999'
          value={organizationId} onChange={handleChange} tooltip='Please enter the first 6 digits of the Lender/Servicer ID.' required
          onInvalid={handleInvalid} error={errors.organizationId ? errors.organizationId : namedMinLength('Lender/Servicer ID', '6')(organizationId)} />
        <BasicLgySelectField label='Audit Location' id='auditLocationCode' name='auditLocationCode' value={auditLocationCode} onChange={handleChange}
          required onInvalid={handleInvalid} error={errors.auditLocationCode ? errors.auditLocationCode : undefined}>
          <option value='T'>Travel</option>
          <option value='V'>Virtual</option>
        </BasicLgySelectField>
        {auditingUnitCode === 'M' && <div className='audit-number'>
          <span>{fullAuditNumber()}</span>
          <BasicLgyInputField label='Audit Number' type='number' id='auditNumber' name='auditNumber' min='1' max='999'
            value={auditNumber} onChange={handleChange} required onInvalid={handleInvalid} error={errors.auditNumber ? errors.auditNumber : 
            namedValueBetween('Audit Number', 1, 999)(auditNumber)} />
        </div>}
      </fieldset>
      <fieldset className='usa-fieldset-inputs usa-sans'>
        <legend>Audit Dates</legend>
        <div className={dateErrors.notificationDate ? 'usa-input-error' : ''}>
          <label>Notification Date</label>
          {dateErrors.notificationDate && <span className='usa-input-error-message' role='alert'>{dateErrors.notificationDate}</span>}
          <DatePicker id='notificationDate' name='notificationDate' className={notificationDate ? 'usa-input-success' : ''} selected={notificationDate}
            onChange={handleDateChange('notificationDate')} dateFormat='MMMM d, yyyy' placeholderText='Notification Date' />
        </div>
        <div className={dateErrors.closeOutDate ? 'usa-input-error' : ''}>
          <label>Close-Out Date</label>
          {dateErrors.closeOutDate && <span className='usa-input-error-message' role='alert'>{dateErrors.closeOutDate}</span>}
          <DatePicker id='closeOutDate' name='closeOutDate' className={closeOutDate ? 'usa-input-success' : ''} selected={closeOutDate}
            onChange={handleDateChange('closeOutDate')} dateFormat='MMMM d, yyyy' placeholderText='Close-Out Date' />
        </div>
      </fieldset>
      <br />
      <ul className='usa-accordion'>
        <li>
          <button className='usa-accordion-button' aria-expanded='false' aria-controls='a1'>
            VA Audit Point Of Contact (Optional)
          </button>
          <div id='a1' className='usa-accordion-content'>
            <fieldset>
              <BasicLgyInputField label='First Name' type='text' id='vaPocFirstName' name='vaPocFirstName' maxLength='20'
                value={vaPocFirstName} onChange={handleChange} />
              <BasicLgyInputField label='Middle Initial' type='text' id='vaPocMiddleInitial' name='vaPocMiddleInitial' maxLength='1'
                value={vaPocMiddleInitial} onChange={handleChange} />
              <BasicLgyInputField label='Last Name' type='text' id='vaPocLastName' name='vaPocLastName' maxLength='20'
                value={vaPocLastName} onChange={handleChange} />
              <BasicLgyInputField label='Email' type='text' id='vaPocEmail' name='vaPocEmail' maxLength='100' value={vaPocEmail}
                onChange={handleChange} error={validations.email(vaPocEmail)} />
              <BasicLgyInputField label='Primary Phone Number' type='text' id='vaPocPrimaryPhone' name='vaPocPrimaryPhone' maxLength='15'
                value={formatPhone(vaPocPrimaryPhone)} onChange={handleChange} error={validations.phoneNumber(vaPocPrimaryPhone)} />
              <BasicLgyInputField label='Secondary Phone Number' type='text' id='vaPocSecondaryPhone' name='vaPocSecondaryPhone' maxLength='15'
                value={formatPhone(vaPocSecondaryPhone)} onChange={handleChange} error={validations.phoneNumber(vaPocSecondaryPhone)} />
            </fieldset>
          </div>
        </li>
        <li>
          <button className='usa-accordion-button' aria-expanded='false' aria-controls='a2'>
            Lender/Servicer Point Of Contact (Optional)
          </button>
          <div id='a2' className='usa-accordion-content'>
            <fieldset>
              <BasicLgyInputField label='First Name' type='text' id='orgPocFirstName' name='orgPocFirstName' maxLength='20'
                value={orgPocFirstName} onChange={handleChange} />
              <BasicLgyInputField label='Middle Initial' type='text' id='orgPocMiddleInitial' name='orgPocMiddleInitial' maxLength='1'
                value={orgPocMiddleInitial} onChange={handleChange} />
              <BasicLgyInputField label='Last Name' type='text' id='orgPocLastName' name='orgPocLastName' maxLength='20'
                value={orgPocLastName} onChange={handleChange} />
              <BasicLgyInputField label='Email' type='text' id='orgPocEmail' name='orgPocEmail' maxLength='100' value={orgPocEmail}
                onChange={handleChange} error={validations.email(orgPocEmail)} />
              <BasicLgyInputField id='orgPocAddressOne' name='orgPocAddressOne' type='text' value={orgPocAddressOne} maxLength='100'
                label='Address Line One' onChange={handleChange} />
              <BasicLgyInputField id='orgPocAddressTwo' name='orgPocAddressTwo' type='text' value={orgPocAddressTwo} maxLength='100'
                label='Address Line Two' onChange={handleChange} />
              <BasicLgyInputField id='orgPocCity' name='orgPocCity' type='text' value={orgPocCity} maxLength='50'
                label='City' onChange={handleChange} />
              <BasicLgySelectField label='State' id='orgPocStateCode' name='orgPocStateCode' value={orgPocStateCode} onChange={handleChange}>
                {oversightstates.map(state => <option key={state.cd} value={state.cd}>{state.label}</option>)}
              </BasicLgySelectField>
              <BasicLgyInputField label='Zip' type='number' id='orgPocZip' name='orgPocZip' min='00501' max='99950'
                value={orgPocZip} onChange={handleChange} error={validateZip(orgPocZip)} />
              <BasicLgyInputField label='Primary Phone Number' type='text' id='orgPocPrimaryPhone' name='orgPocPrimaryPhone' maxLength='15'
                value={formatPhone(orgPocPrimaryPhone)} onChange={handleChange} error={validations.phoneNumber(orgPocPrimaryPhone)} />
              <BasicLgyInputField label='Secondary Phone Number' type='text' id='orgPocSecondaryPhone' name='orgPocSecondaryPhone' maxLength='15'
                value={formatPhone(orgPocSecondaryPhone)} onChange={handleChange} error={validations.phoneNumber(orgPocSecondaryPhone)} />
            </fieldset>
          </div>
        </li>
      </ul>
      {auditRecord.success &&
        <LgyAlertDialog type='success' heading={isEdit ? 'Audit Edited' : 'Audit Created'}>
          <div>
            Successfully {isEdit ? 'edited' : 'created new'} audit file.&nbsp;
          <LgyLink to={`/lgyhub/oversight/audits/${auditRecord.audit.id}`}>View audit.</LgyLink>
          </div>
        </LgyAlertDialog>}
        {auditRecord.error &&
        <LgyAlertDialog type='error' heading={isEdit ? 'Error Editing Audit' : 'Audit Not Created'}>
          <div>An error occurred while {isEdit ? 'editing' : 'creating'} this audit. {auditRecord.message}</div>
        </LgyAlertDialog>}
      <LgyFormSubmit
        pristine={auditingUnitCode === '' && auditFiscalYear === '' && auditTypeCode === '' && organizationId === '' && organizationEntityTypeId === '' &&
          auditLocationCode === '' && auditNumber === '' && notificationDate === undefined && closeOutDate === undefined}
        submitting={auditRecord.posting}
        submitSucceeded={auditRecord.success}
        submitFailed={auditRecord.error}
        invalid={Object.keys(errors).length > 0 || auditRecord.success} />
      <button type='button' className='usa-button-secondary reset-button' disabled={auditRecord.posting} onClick={handleReset}>{auditRecord.success && !isEdit ? 'Create New Audit' : 'Reset'}</button>
    </form>
  </div>
}

export default AddEditAuditForm
